import { ArrowUp, Plus } from '@untitled-ui/icons-react/build/cjs';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ButtonCmp from 'src/components/ButtonCmp';
import InputText from 'src/components/InputText/InputText';
import OrbAvatar from 'src/components/OrbAvatar';
import { RootState } from 'src/redux/store';

import { openAgentConversationPanelWithMessage } from '../AgentConversationPanel/agentConversationPanel.slice';

const SUGGESTIONS = ['I want to create a shipment', "What's the status on my shipment?", 'How do I track a shipment?'];

const AskDashboardComposer = () => {
    const dispatch = useDispatch();
    const [value, setValue] = useState('');
    // Feature gate: resolved portal visibility comes from getUserDetails API → auth.portalVisibility
    const isAgentViewVisible = useSelector((state: RootState) => state.auth.portalVisibility?.enableAgentView === true);

    const handleSubmit = () => {
        if (!value.trim()) return;
        dispatch(openAgentConversationPanelWithMessage(value.trim()));
        setValue('');
    };

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSubmit();
        }
    };

    if (!isAgentViewVisible) return null;

    return (
        <div className="flex flex-col gap-2 mb-3">
            <div className="rounded-xl bg-white border border-borderPrimary shadow-xs">
                <InputText
                    value={value}
                    onChangeFunc={(e) => setValue(e.target.value)}
                    handleKeyDown={handleKeyDown}
                    placeholder="Ask anything..."
                    parentClassName="px-0 pt-3 pb-6"
                    className="!border-0 !bg-transparent !shadow-none !outline-none !ring-0 !px-3 !py-0 !text-[12px] !leading-[18px] !h-auto"
                    inputName="askDashboard"
                    inputType="text"
                />

                <div className="flex items-center justify-between px-3 pt-1 pb-3">
                    <OrbAvatar size={24} />

                    <div className="flex items-center gap-2">
                        <ButtonCmp type="button" size="none" className="!shadow-none !bg-transparent text-grayLight400 hover:text-grayLight700">
                            <Plus className="h-4 w-4" />
                        </ButtonCmp>

                        <ButtonCmp
                            type="button"
                            size="none"
                            className="h-[22px] w-[22px] !rounded-full !bg-primary !border-0 !shadow-none !text-white hover:!bg-primary700 transition-colors"
                            onClick={handleSubmit}
                            disabled={!value.trim()}
                        >
                            <ArrowUp className="h-3.5 w-3.5" />
                        </ButtonCmp>
                    </div>
                </div>
            </div>

            <div className="flex flex-wrap gap-2">
                {SUGGESTIONS.map((suggestion) => (
                    <ButtonCmp key={suggestion} type="button" className="btn_secondary_black" onClick={() => setValue(suggestion)}>
                        {suggestion}
                    </ButtonCmp>
                ))}
            </div>
        </div>
    );
};

export default AskDashboardComposer;
